/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLocation, useNavigate } from "react-router-dom";
import DeliveryDetailModal from "./Component/DeliveryDetailModal";
import { DeliveryItemListTblCard } from "./Component/DeliveryItemListTblCard";
import {
  Delivery_ItemList_Post,
  Get_Delivery_ItemList,
} from "../../Server/ApiV2";
import { DeliveryList_Set, Set_SliceDelivery_DetailObj } from "./SliceDelivery";
import { useDispatch, useSelector } from "react-redux";
import Delivery_BreadCrumbs from "./Delivery_BreadCrumbs";
import { fAlertToast } from "../../Utility/Utilitys";
import { confirmAlert } from "react-confirm-alert";

export default function DeliveryDetail() {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const route = useLocation();

  const vRdxDelivery = useSelector(
    (state) => state.SliceDelivery.value.HeadObj
  );
  const [sDeliverItemList, setDeliverItemList] = useState([]);

  const getDeliveryItemList = async () => {
    const req = await Get_Delivery_ItemList({
      v_VocTyp: vRdxDelivery.VocTyp,
      v_VocNo: vRdxDelivery.VocNo,
      v_Version: vRdxDelivery.Version,
    });

    if (req?.status === 200) {
      const deliveryItemsWithId = req.data.ResultSet.map((item, index) => ({
        ...item,
        id: index + 1, // Assuming the index starts from 1
      }));
      setDeliverItemList(deliveryItemsWithId);
      //setDeliverItemList(req.data.ResultSet);
    }
  };

  const Post =async()=>{
    const req = await Delivery_ItemList_Post({
      VocTyp: vRdxDelivery.VocTyp,
      VocNo: vRdxDelivery.VocNo,
      version: vRdxDelivery.Version,
    });

    if (req?.status === 200) {
      navigate("/deliverySummary");
    }
  }
  useEffect(() => {
    getDeliveryItemList();
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="mb-2">
        <Delivery_BreadCrumbs />
      </div>
      <div className="Instant-picking-head">
        <Grid
          container
          spacing={{ xs: 0, sm: 2, md: 1 }}
          className="align-items-center mt-4"
        >
          <Grid item   md={1.2} xs={3.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={"Voc.Type "  }
            />
          </Grid>
          <Grid item   md={0.3} xs={0.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={" : "  }
            />
          </Grid>
          <Grid item   md={1.5} xs={8}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={ vRdxDelivery.VocTyp}
            />
          </Grid>
          <Grid item   md={1.2} xs={3.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={"Voc.No " }
            />
          </Grid>
          <Grid item   md={0.3} xs={0.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={" : "  }
            />
          </Grid>
          <Grid item   md={1.5} xs={8}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={ vRdxDelivery.VocNo}
            />
          </Grid>
          <Grid item   md={1.2} xs={3.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={"Status "  }
            />
          </Grid>
          <Grid item   md={0.3} xs={0.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={" : "  }
            />
          </Grid>
          <Grid item   md={1.5} xs={6}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={ vRdxDelivery.DeliveryStatus}
            />
          </Grid>
          <Grid item   md={1.2} xs={3.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={"RefDocNo "  }
            />
          </Grid>
          <Grid item   md={0.3} xs={0.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={" : "  }
            />
          </Grid>
          <Grid item   md={1.5} xs={6}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize="20px"
              xText={ vRdxDelivery.RefDocNo}
            />
          </Grid>
        </Grid>

        <DeliveryItemListTblCard
          data={sDeliverItemList}
          onClick={(item) => {
            dispatch(Set_SliceDelivery_DetailObj(item.row));

            navigate("/deliveryItemDetail");
          }}
          setDeliverItemList={setDeliverItemList}
          VocNo={vRdxDelivery.VocNo}
        />
        <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 1 }}
          className="align-items-center   mt-4"
        >
          <Grid item xs={12} md={12} className="text-center">
            <CmpButton
              xbtnName="Post"
              xOnClick={async () => {
                const invalidItem = sDeliverItemList.find(
                  (item) => item.ConfirmQty !== item.Qty
                );  
                if (invalidItem) {
                  setTimeout(async () => {
                    confirmAlert({
                      title: "Save",
                      message: `Confirm quantity and quantity mismatch (SrNo: ${invalidItem.SrNo}), ConfirmQty (${invalidItem.ConfirmQty}) does not match Qty (${invalidItem.Qty}),Are you want to post.`
                     ,
                      buttons: [
                        {
                          className: "alertBtn",
                          name: "SaveYes",
                          label: "Yes",
                          onClick: async () => {
                            await Post()
                          },
                        },
                        {
                          className: "alertBtn",
                          label: "No",
                          onClick: () => {
                            return;
                          },
                        },
                      ],
                    });
                  }, 100);
                }else{
                  await Post()
                } 
              }}
              xVariant="contained"
              xSize="small"
              xDisabled={vRdxDelivery.DeliveryStatus != "ENTER"}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
